<template>
  <div>
    <v-container class="importBrands">
      <v-row>
        <v-col md="8" offset-md="2" sm="12" cols="12" class="text-left">
          <h3>{{ $store.state.eventname }}::{{ $t("dashboard.menu.importBrands.title") }}</h3>
        </v-col>
        <v-col md="8" offset-md="2" sm="12" cols="12" class="text-left">
          <v-select 
            :label="$t('dashboard.menu.importBrands.choose_event')" 
            v-model="chooseEvent" 
            :items="eventItems" 
            item-text="eventName" 
            item-value="id"
            @change="change()"
            :no-data-text="$t('common.no_data')"
          ></v-select>
          <span>{{ $t("dashboard.menu.importBrands.you_can_only") }}</span>
        </v-col>
        <v-col md="8" offset-md="2" sm="12" cols="12">
          <v-list dense>
            <v-subheader>{{ $t("dashboard.menu.importBrands.name") }}</v-subheader>
            <v-list-item-group v-model="model" color="primary">
              <v-list-item v-for="(item, i) in items" :key="i">
                <v-list-item-content>
                  <v-list-item-title v-text="item.brandName"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="8" offset-md="2" class="text-right">
          <v-btn @click="importBrands" color="primary">
            {{
            $tc("dashboard.menu.importBrands.import")
            }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import { mapState } from 'vuex';
export default {
  mixins: [apiCalls],
  name: "ImportBrands",
  data() {
    return {
      chooseEvent: "",
      eventName: "",
      items: [],
      eventItems: [],
      userId: null,
      model: null
    };
  },
  computed: {
    ...mapState(['events']),
  },
  mounted() {
    this.getListEvent();
  },
  methods: {
    async change(){
      
       var response = await this.api("get", `/api/v1/promoter/brand/${this.userId}/${this.chooseEvent}`);

      if(response.success == 1){
        this.items = response.message;
      }
    },
    async importBrands() {
      //Send list to view eventBrand
      var brand = this.items[this.model];
      let data = {};
      
      data.eventId = this.$route.params.id;
      data.importId = brand.eventId;
      data.userId = this.userId;     

      var response = await this.postApi("/api/v1/promoter/brand/import", data);

      
      if(response.success == 1){
        this.$router.push({ name: 'EventBrands', params: { id: this.$route.params.id }});
      }
      
    },
    async getListEvent(){
      var response = await this.api("get", "/api/v1/promoter/createRace/getUserEvents");
      
      if(response.success == 1){
        this.eventItems = response.message;
        this.userId = response.message[0].userId;
      }
    }
  }
};
</script>
<style>
.importBrands .v-subheader {
  background: var(--v-accent-base);
  /*color: var(--v-primary-darken1) !important;*/
  font-size: 14px;
}
.v-list-item {
  border-bottom: solid 1px var(--v-secondary-base);
}
</style>
